import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';

export const PreviewResumeEducationItem = memo(
  ({ item: { id, university = '', degree = '', major = '', start, end } }) => {
    const { styles } = useStyle();
    const periodText = [...(start ? [start] : []), ...(end ? [end] : [])].join(
      ' - '
    );
    return (
      <View style={[styles.container]}>
        <Text style={styles.text}>{`${degree} ${major}`}</Text>
        <Space size={8} />
        <Text style={styles.subText}>{university}</Text>
        <Text style={styles.subText}>{periodText}</Text>
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    backgroundColor: colors.cardBackground,
    padding: 16,
    borderRadius: 10,
  },
  text: {
    fontSize: 16,
    color: colors.title,
    fontWeight: 'bold',
  },
  subText: {
    fontSize: 14,
    color: colors.subtitle,
  },
}));
